export class LocationRequest {
  Id: number;
  Status: string;
  Name: string;
  Description: string;
  PrimaryPhoneNumber: string;
  WebAddress: string;
  Address1: string;
  Address2: string;
  City: string;
  State: string;
  ZipCode: string;
  Country: string;
  Hours: string;
  Fax: string;
  CleanZipCode: string;
  Latitude: string;
  Longitude: string;
  GlobalLocationId: number;
}

